import { PayrollEntryDetailsFragment } from "../../../../lib/graphql/generated";

export function getSelectedEmployees(
  employees: PayrollEntryDetailsFragment["employees"],
  employeeIds?: string[]
) {
  if (!employeeIds?.length) {
    return employees;
  }

  const allowedIds = new Set(employeeIds);
  return employees.filter((employee) => allowedIds.has(employee.id));
}
